import styled from 'styled-components';
import { font, fontSize } from '../assets/common';
export const TooltipText = styled.span`
  display: inline-block;
  font-family: ${font.inter};
  font-size: ${(props) => (props.size === 'small' ? fontSize.small : '12px')};
  color: ${(props) => (props.hadColor ? 'red' : '')};
  margin-right: 4px;
`;
